/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
import React from "react";

import { Grid, Skeleton } from "@mui/material";
import { useDadosComplementaresV2 } from "services/api";
import { RootStateOrAny, useSelector } from "react-redux";
import * as Styles from "../../styles";
import DadosComplementaresForm from "../dadosComplementaresForm";
import { AuthState } from "../../../../store/ducks/auth/types";
import SkeletonDadosComplementares from "./components/SkeletonDadosComplementares";

type FormRowProps = {
  isDataLoading: boolean;
  data: [
    { title: string; subtitle: string },
    { title: string; subtitle: string },
    { title: string; subtitle: string }
  ];
};

function FormRow({ data, isDataLoading }: FormRowProps) {
  return (
    <>
      <Grid item xs={4}>
        <Styles.ContainerDadosComp>
          <p>{data[0].title}</p>
          {isDataLoading ? (
            <Skeleton variant="rounded" width="100px" height={20} />
          ) : (
            <p>{data[0].subtitle}</p>
          )}
        </Styles.ContainerDadosComp>
      </Grid>
      <Grid item xs={4}>
        <Styles.ContainerDadosComp>
          <p>{data[1].title}</p>
          {isDataLoading ? (
            <Skeleton variant="rounded" width="100px" height={20} />
          ) : (
            <p>{data[1].subtitle}</p>
          )}
        </Styles.ContainerDadosComp>
      </Grid>
      <Grid item xs={4}>
        <Styles.ContainerDadosComp>
          <p>{data[2].title}</p>
          {isDataLoading ? (
            <Skeleton variant="rounded" width="100px" height={20} />
          ) : (
            <p>{data[2].subtitle}</p>
          )}
        </Styles.ContainerDadosComp>
      </Grid>
    </>
  );
}

interface Props {
  closeModal: Function;
  idLeadCorretor: string;
  readOnly?: boolean;
}

export function DadosComplementares(props: Props) {
  const { codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const isCorretor =
    codigoCargo2013 === "219.840.002" ||
    codigoCargo2013 === "219.840.012" ||
    codigoCargo2013 === "219.840.001";
  const showForm = isCorretor || props.readOnly;
  const {
    data: dataLead,
    refetch: refetchDataLead,
    isRefetching: isRefetchingDataLead,
    isFetched,
  } = useDadosComplementaresV2({
    idLeadCorretor: props.idLeadCorretor,
    queryKey: "dados-complementares-lead-detail",
  });
  React.useEffect(() => {
    refetchDataLead();
  }, []);

  return (
    <div style={{ padding: "0 1.5rem" }}>
      <Styles.SubTitleInfo>
        Você pode incrementar mais informações para o seu lead, isso te ajudará
        a fazer uma gestão mais personalizada para cada lead
      </Styles.SubTitleInfo>
      {showForm ? (
        !isFetched || isRefetchingDataLead ? (
          <SkeletonDadosComplementares />
        ) : isFetched ? (
          <DadosComplementaresForm
            data={dataLead}
            readOnly={props.readOnly}
            closeModal={() => {
              props.closeModal();
            }}
          />
        ) : null
      ) : null}
      {!showForm ? (
        <Grid container spacing={1}>
          <Grid container item spacing={3}>
            <FormRow
              isDataLoading={isRefetchingDataLead}
              data={[
                {
                  title: "Data de nascimento",
                  subtitle: dataLead?.dataNascimento || "--",
                },
                {
                  title: "Profissão",
                  subtitle: dataLead?.profissao || "--",
                },
                {
                  title: "Estado Civil",
                  subtitle: dataLead?.estadoCivil || "--",
                },
              ]}
            />
          </Grid>
          <Grid container item spacing={3}>
            <FormRow
              isDataLoading={isRefetchingDataLead}
              data={[
                {
                  title: "Renda familiar",
                  subtitle: dataLead?.rendaFamiliar || "--",
                },
                {
                  title: "Sexo",
                  subtitle: dataLead?.sexo || "--",
                },
                {
                  title: "Objetivo da compra",
                  subtitle: dataLead?.objetivoCompra || "--",
                },
              ]}
            />
          </Grid>
          <Grid container item spacing={3}>
            <FormRow
              isDataLoading={isRefetchingDataLead}
              data={[
                {
                  title: "CEP",
                  subtitle: dataLead?.cep || "--",
                },
                {
                  title: "Cidade",
                  subtitle: dataLead?.cidade || "--",
                },
                {
                  title: "Bairro",
                  subtitle: dataLead?.bairro || "--",
                },
              ]}
            />
          </Grid>
        </Grid>
      ) : null}
      {!showForm ? (
        <Styles.FooterDialog>
          <Styles.Button
            style={{ width: "100%" }}
            variant="outlined"
            onClick={() => {
              props.closeModal();
            }}
          >
            Fechar
          </Styles.Button>
        </Styles.FooterDialog>
      ) : null}
    </div>
  );
}
